import { HouseIcon, MapPinIcon, PersonIcon, StorefrontIcon } from '@phosphor-icons/react'

export const returnInstructionTypes = {
  homePickup: 'home_pickup',
  shipItYourself: 'ship_it_yourself',
  dropoffPoint: 'dropoff_point',
  storeDropoff: 'store_dropoff',
}

export const iconByReturnInstructionType = {
  [returnInstructionTypes.homePickup]: HouseIcon,
  [returnInstructionTypes.shipItYourself]: PersonIcon,
  [returnInstructionTypes.dropoffPoint]: MapPinIcon,
  [returnInstructionTypes.storeDropoff]: StorefrontIcon,
}

export const labelByReturnInstructionType = {
  [returnInstructionTypes.homePickup]: 'Recogida a domicilio',
  [returnInstructionTypes.shipItYourself]: 'Envíalo por tu cuenta',
  [returnInstructionTypes.dropoffPoint]: 'Punto de entrega',
  [returnInstructionTypes.storeDropoff]: 'Entrega en tienda',
}
